module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Iain Levison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Iain Levison is the author of "), _c('I', [_vm._v("A Working Stiff’s Manifesto")]), _vm._v(", an account of his post-collegiate work experience, consisting of forty-two jobs in ten years, and of two previous novels, "), _c('I', [_vm._v("Since the Layoffs")]), _vm._v(" and "), _c('I', [_vm._v("Dog Eats Dog")]), _vm._v(". He lives in Raleigh, North Carolina.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tC8Z3Z/tc-custom/9781569479216.jpg?1705865476560",
      "alt": "This image is the cover for the book Since the Layoffs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Since the Layoffs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This “dark, satirical comedy [is] written with the deadpan humor Levison used so well in his first book, "), _c('i', [_vm._v("A Working Stiff’s Manifesto")]), _vm._v("” ("), _c('i', [_vm._v("USA Today")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Jake Skowran has been laid off from his job as a factory supervisor. Fortunately, he’s been offered other work. Unfortunately, it is as a hired killer."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Beset by creditors and filled with fury over his situation, Jake decides he has little choice except to take it. He is going to carve off a piece of the economy or die trying . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Like Donald Westlake in "), _c('i', [_vm._v("The Ax")]), _vm._v(", about an insurance executive turned hit man, Levison brings a burning rage to this accomplished debut novel.” —"), _c('i', [_vm._v("Booklist")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[A] black comedy of morals cracking in a lousy economy.” —"), _c('i', [_vm._v("The New York Times Book Review")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Soho Press, Inc.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0